<template>
  <div class="youth-influence">
    <SectionLabel class="youth-influence__title" text="年輕人重要嗎？"/>
    <div class="youth-influence__population"><!--
    --><PopulationChart class="youth-influence__population-chart"/><!--
    --><PopulationAnalysis class="youth-influence__population-analysis"/>
    </div>
    <PopulationTopic class="youth-influence__population-topic"/>
    <VotingAgeChart class="youth-influence__voting-age-chart"/>
  </div>
</template>

<script>
import SectionLabel from '@/components/SectionLabel'
import PopulationChart from '@/components/PopulationChart'
import PopulationAnalysis from '@/components/PopulationAnalysis'
import PopulationTopic from '@/components/PopulationTopic'
import VotingAgeChart from '@/components/VotingAgeChart'

export default {
  name: 'YouthInfluence',
  components: {
    SectionLabel,
    PopulationChart,
    PopulationAnalysis,
    PopulationTopic,
    VotingAgeChart
  }
}
</script>

<style lang="scss">
.youth-influence {
  $comp: &;
  padding: 80px 0 100px 0;
  background:
    url(~@/assets/arrow-top-bg-red.png) repeat-x -50px top,
    #eeeeee url(~@/assets/arrow-bottom-bg-white.png) repeat-x 20px bottom;

  &__title {
    @include rwd($RWD_TABLET_SMALL) {
      margin-top: 15px;
    }
    @include rwd($RWD_TABLET) {
      margin-top: 35px;
    }
    @include rwd($RWD_DESKTOP) {
      margin-top: 25px;
    }
    @include rwd($RWD_DESKTOP_WIDE) {
      margin-top: 15px;
    }
    @include rwd($RWD_DESKTOP_WIDE_1440) {
      margin-top: 25px;
    }
  }

  &__population {
    margin-top: 55px;
    @include rwd($RWD_DESKTOP) {
      margin-top: 70px;
    }
    @include rwd($RWD_DESKTOP_WIDE) {
      width: 83%;
      max-width: 1240px;
      margin: 85px auto;
    }
  }

  &__population-chart {
    @include rwd($RWD_TABLET_SMALL) {
      width: 480px;
      margin: 0 auto;
    }
    @include rwd($RWD_TABLET) {
      width: 670px;
    }
    @include rwd($RWD_DESKTOP) {
      width: 700px;
    }
    @include rwd($RWD_DESKTOP_WIDE) {
      display: inline-block;
      width: 50%;
      vertical-align: top;
    }
  }

  &__population-analysis {
    margin: 20px 20px 30px 20px;
    @include rwd($RWD_TABLET_SMALL) {
      width: 470px;
      margin: 25px auto;
    }
    @include rwd($RWD_TABLET) {
      width: 510px;
    }
    @include rwd($RWD_DESKTOP) {
      width: 630px;
    }
    @include rwd($RWD_DESKTOP_WIDE) {
      display: inline-block;
      width: 50%;
      margin: 0;
      margin-top: -5px;
      padding-left: 30px;
      vertical-align: top;
    }
    @include rwd($RWD_DESKTOP_WIDE_1440) {
      margin-top: 50px;
    }
  }

  &__population-topic {
    margin: 18px;
    @include rwd($RWD_TABLET_SMALL) {
      width: 460px;
      margin: 50px auto;
    }
    @include rwd($RWD_TABLET) {
      width: 500px;
      margin: 60px auto;
    }
    @include rwd($RWD_DESKTOP) {
      width: 630px;
      margin: 90px auto 110px auto;
    }
    @include rwd($RWD_DESKTOP_WIDE) {
      width: 750px;
      margin: 100px auto 90px auto;
    }
  }

  &__voting-age-chart {
    width: 90%;
    margin: 0 auto;
    @include rwd($RWD_TABLET_SMALL) {
      max-width: 450px;
    }
    @include rwd($RWD_TABLET) {
      max-width: 650px;
    }
    @include rwd($RWD_DESKTOP) {
    }
    @include rwd($RWD_DESKTOP_WIDE) {
      max-width: 800px;
    }
  }
}
</style>
